// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__oh5kW","container":"Header_container__v4Zn3","title":"Header_title__c_SMt","solutions":"Header_solutions__NjCZ_"};